import React from 'react';
import { TabsOrentations } from './MTabs.model';

import MTabsNav from './MTabsNav/MTabsNav';

type Props<Tabs extends string> = {
  className?: string;
  activeTab: Tabs;
  classNameItem?: string;
  classNameItemSelected?: string;
  orientation?: TabsOrentations;
  onTabClick: (tab: Tabs) => void;
};

const MTabsView = <Tabs extends string>(props: React.PropsWithChildren<Props<Tabs>>): JSX.Element => {
  return (
    <React.Fragment>
      <MTabsNav
        activeTab={props.activeTab}
        orientation={props.orientation}
        classNameItem={props.classNameItem}
        classNameItemSelected={props.classNameItemSelected}
        className={props.className}
        onTabClick={props.onTabClick}
      >
        {props.children}
      </MTabsNav>
      {React.Children.map(props.children, (child: React.ReactNode) => child && child['props']['id'] === props.activeTab && child)}
    </React.Fragment>
  );
};

MTabsView.displayName = 'MTabsView';

export default MTabsView;
